module.exports = __webpack_public_path__ + "img/tzsdermyy.f746491f.png";